import { TextField } from "@mui/material";
import { NumericFormat } from 'react-number-format';
import { formatLabel } from "../utils";
export default function DecimalField({
  formStateHandlers,
  fieldSetting,
  inputProps,
  ...props
}) {
  const { number, raw } = formStateHandlers;
  const defaultFieldConfig = number(fieldSetting);
  const fieldConfig = raw({
    ...defaultFieldConfig,
    onChange: (input) => {
      const normalizedValue = input.target.value.replace(',', '.');
      const value = parseFloat(normalizedValue);
      fieldSetting.onChange({
        target: {
          fieldname: fieldSetting.name,
          value,
        },
      });
      return value;
    },
  });
  
  return (
    <NumericFormat
      {...fieldConfig}
      {...props}
      inputProps={{
        ...inputProps,
      }}
      InputProps={{
        // Prevent scrolling from changing the input value
        onWheel: (e) => {
          e.target.blur();
        },
      }}
      customInput={TextField}
      valueIsNumericString
      allowedDecimalSeparators={['.', ',']}
      decimalSeparator=","
      decimalScale={props.data?.decimals ?? 0} 
      label={formatLabel(props.data)}
      error={props.data?.isFieldFailed}
      InputLabelProps={{
        // hard coded to true to position label above input
        shrink: true,
        // hard coded to false to prevent an asterisk from showing
        required: false,
      }}
    />
  );
}
